import React from "react";

const SectionForm = ({ title, children }) => {
	return (
		<section className="section-form">
			<header className="section__head">
				<div className="shell">
					<div className="section__entry">
						<h5>{title}</h5>
					</div>
				</div>
			</header>

			<div className="section__body">{children}</div>
		</section>
	);
};

export default SectionForm;
